// @flow

import * as React from "react";
import { Link } from "react-router-dom";
import { Button as BootstrapButton } from "react-bootstrap";

type Props = {
  url: string,
  className: string,
  children?: React.Node,
  disabled?: boolean,
  bsStyle?: string
};

const Button = (props: Props) => (
  <Link to={props.url}>
    <BootstrapButton
      bsStyle={props.bsStyle}
      bsSize="large"
      className={props.className}
      disabled={props.disabled}
    >
      {props.children}
    </BootstrapButton>
  </Link>
);

export default Button;



// WEBPACK FOOTER //
// ./src/components/ActionButton/ActionButton.js